module.exports = __webpack_public_path__ + "static/media/Coursera.3fc1833d.png";